import { render } from "./Filter.vue?vue&type=template&id=39c9bc08&scoped=true&ts=true"
import script from "./Filter.vue?vue&type=script&lang=ts"
export * from "./Filter.vue?vue&type=script&lang=ts"

import "./Filter.vue?vue&type=style&index=0&id=39c9bc08&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c9bc08"]])

export default __exports__